const getApiError = (res) => {
    return res?.message || res?.errors?.message || res?.errors?.[0]?.message || ''
}

export default getApiError
